<template>
  <div class="supplier-from">
      <div class="pd-15">
        <el-form ref="configForm" :model="form" label-width="110px" :rules="rules">
          <el-form-item label="付款类型" prop="typeName" style="margin-bottom: 15px !important">
            <el-input v-model="form.typeName" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="科目名称" prop="beanId" style="margin-bottom: 15px !important">
            <el-select v-model="form.beanId" @change="changeSubject" style="width: 300px" @visible-change="showSelect" filterable  :filter-method="filterMethod">
              <el-option v-for="item in subjectList" :key="item.beanId" :label="item.fullName" :value="item.beanId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="摘要内容">
            <el-input v-model="form.summary" type="textarea" style="width: 300px" :autosize="{minRows: 3}" resize="none"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="ta-c mt-15">
        <el-button @click="$emit('closeBox')" size="mini">取消</el-button>
        <el-button @click="save(10)" size="mini" type="primary">保存并新增</el-button>
        <el-button @click="save(20)" size="mini" type="primary">保存并退出</el-button>
      </div>
  </div>
</template>
<script>
import {deepClone} from '@/util'
import {required,validate} from '@/util/rules'
import {
  Req_AddConfig,
  Req_EditConfig,
  Req_GetSubject
} from '@/request/finance'
export default {
  data() {
    return {
      subjectList: [],
      copySubjectList: [],
      subjectMap: {},
      rules: {
        typeName: [required()],
        beanId: [required()]
      }
    }
  },
  props:{
    form:{
      type:Object,
      required:true
    },
  },
  created() {
    this.getSubject()
  },
  methods: {
    changeSubject(val){
      this.form.beanFullName = this.subjectMap[val].fullName
      this.form.beanCode= this.subjectMap[val].fullName.split(' ')[0]
    },
    getSubject(){
      if(this.subjectList.length) return Promise.resolve()
      return Req_GetSubject({
        customerId: this.$store.state.companyInfo.customerId
      }).then(res => {
        res.forEach(item => {
          this.subjectMap[item.beanId] = item
        })
        this.subjectList = res
        this.copySubjectList = deepClone(res)
        return Promise.resolve()
      }).catch(err => this.$catchErr(err))
    },
    filterMethod(val) {
      let list = []
      if(val){
        this.copySubjectList.forEach(item=>{
          if(this.$fuzzyFilter({data:item},val)){
            list.push(item)
          }
        })
      }else{
        list = deepClone(this.copySubjectList)
      }
      this.subjectList = list
    },
    showSelect(state){
      if(state) this.subjectList = deepClone(this.copySubjectList)
    },
    save(type){
      validate(this.$refs.configForm).then(() => {
        const param = deepClone(this.form)
        const method = this.form.configId ? Req_EditConfig : Req_AddConfig
        method({
          ...param
        }).then(res => {
          if(type === 20){
            this.$emit('configSuccess',res)
            this.$emit('addSuccess')
          }else{
            this.$emit('configSuccess',res,false,true)
            this.$emit('addSuccess',false,true)
          }
        }).catch(err => this.$catchErr(err))
      })
      //10 保存并刷新界面
      //20 addState = false
    },
  }
}
</script>

<style lang="scss" scoped>
  .form-box /deep/ .el-dialog__body{
    padding: 0px;
  }
  .form-item-wrap{
    display: flex;
  }
  .assist-top-title{
    p{
      font-size: 16px;
      font-weight: bold;
      margin: 10px 0;
    }
  }
  .assist-bottom-title{
    p{
      font-size: 14px;
      margin: 10px 0;
      color: red;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Finance/ReimTypeForm.vue